import React from 'react';
import { Badge } from '@mantine/core';

/**
 * A badge component that displays text with a subtle background color and a bottom border matching the badge color.
 */
const SubtleBadge = ({ badgeColor, text, ...props }: any) => {
  return (
    <>
      <Badge c={badgeColor} variant={'subtle'} style={{ borderBottom: `2px solid ${badgeColor}` }} {...props}>
        {text}
      </Badge>
    </>
  );
}

export default SubtleBadge;